import { React, useState, useEffect } from 'react';
import Select from 'react-select';
import { PiTagFill } from 'react-icons/pi';
import { FaTrash, FaTimes } from 'react-icons/fa';
import ApiService from '../../../../services/apiService';
import ApiService2 from '../../../../../INVENTORY/services/apiService';

import { ClipLoader } from 'react-spinners';
import { FaAngleLeft } from 'react-icons/fa6';
import { FaSave } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { getTaxExplicit, getTaxImplicit } from '../../../../../Redux/selecters';
import { useSelector } from 'react-redux';

const AddItemsMaster = () => {
  const location = useLocation();

  const taxExplicit = useSelector(getTaxExplicit); // true if tax added-on
  const taxImplicit = useSelector(getTaxImplicit); // true if tax included
  const [itemDetaillsTab, setItemTab] = useState(true);
  const [priceTab, setPriceTab] = useState(false);
  const [loyaltyTag, setLoyalityTag] = useState(false);
  const [productTypeTag, setProductTag] = useState(false);
  const [tags, setTags] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [selectedType, setSelectedType] = useState('Standard');
  const [isVariantEnabled, setIsVariantEnabled] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [productsList, setProductsList] = useState([]);
  const [vat, setvat] = useState([]);
  const [loader, setLoader] = useState(false);
  const [attributes, setAttributes] = useState([]);
  const [isTracking, setIsTracking] = useState(false);
  const [variants, setVariants] = useState([]);
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [unitMeasurement, setunitMeasurement] = useState([]);
  const [packingUom, setPackingUOMOptions] = useState([]);
  const [packingType, setPackingType] = useState([]);
  const [stockType, setStockType] = useState([]);
  const [Assests, setAssets] = useState(false);
  const [supplier, setSupplier] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [ItemCode, setItemCode] = useState();
  const [productTypes, setProductTypes] = useState([]);
  const [brands, setBrands] = useState([]);
  const navigate = useNavigate();
  const apiService = new ApiService();
  const apiService2 = new ApiService2();

  const [Active, setActive] = useState(true);
  // Add state at the top with other states:
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  // Validation errors state
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        // Fetch category options
        const categoryResponse = await apiService.get('GET_CATEGORY_MASTER');

        if (categoryResponse?.data?.result && Array.isArray(categoryResponse.data.result)) {
          const activeCategories = categoryResponse.data.result.filter((cat) => cat.active === 1);
          setCategoryOptions(activeCategories);
        } else {
          setCategoryOptions([]);
        }

        // Fetch sub-category options
        const subCategoryResponse = await apiService.get('GET_SUB_CATEGORY_MASTER');
        setSubCategories(subCategoryResponse.data.result || []);

        // Inside the second useEffect's fetchDropdownData, add after stockType fetch:
        const warehouseRes = await apiService2.get('GET_WAREHOUSE_MASTER');
        setWarehouseOptions(warehouseRes?.data?.result || []);
      } catch (error) {
        console.error('Error fetching dropdown data:', error);
        setCategoryOptions([]);
        setSubCategories([]);
      }
    };
    fetchDropdownData();
  }, []);

  const [formData, setFormData] = useState({
    itemDescription: '',
    images: [],
    itemName: '',
    supplierName: [],
    supplierCode: [],
    productType: [],
    brandName: [],
    PurchaseAccount: '',
    saleAccount: '',
    supplyPrice: '',
    markup: '',
    retailPrice: '',
    saleTax: [],
    category: [],
    subCategory: [],
    inventoryUom: [],
    packingType: [],
    packingUOM: [],
    TotalRetail: '',
    Volume: '',
    Thickness: '',
    ReorderLevel: '',
    MaxQTY: '',
    Width: '',
    Length: '',
    Height: '',
    Size: '',
    Shape: '',
    MinQTY: '',
    Weight: '',
    convToInvUOM: '',
    sku: '',
    barcode: '',
    ConversitionRate: '1',
    warehouseLocation: null, // react-select object
  });

  const resetFormData = () => {
    setFormData({
      itemNo: null,
      Vat: null,
      reorderLevel: null,
      volume: null,
      length: null,
      warehouseLocation: null, // react-select object

      width: null,
      description: null,
      PackingUnitMeasurement: null,
      Supplier: null,
      PackingType: null,
      height: null,
      fixedAsset: null,
      purchasePrice: null,
      area: null,
      address: null,
      weight: null,
      Category: null,
      SubCategory: null,
      enableLoyalty: null,
      CGS: null,
      address02: null,
      status: null,
      creationDate: null,
      thickness: null,
      size: null,
      shape: null,
      salePrice: null,
      minLevel: null,
      maxLevel: null,
      InventoryUom: null,
      convToInvUOM: null,
      ConversitionRate: '1',
    });
  };

  useEffect(() => {
    const item = location?.state;
    setItemCode(item?.itemNo);
    setFormData((prev) => ({
      ...prev,
      description: item?.itemDescription || '',
      itemNo: item?.recordId || '',
      volume: item?.volume || '',
      length: item?.length || '',
      width: item?.width || '',
      thickness: item?.thickness || '',
      height: item?.height || '',
      createdOn: moment(item?.createdOn).format('YYYY-MM-DD') || '',
      weight: item?.weight || '',
      purchasePrice: item?.purchasePrice || '',
      area: item?.area || '',
      address: item?.address || '',
      size: item?.size || '',
      shape: item?.shape || '',
      enableLoyalty: item?.enableLoyalty || 0,
      minLevel: item?.minLevel || 0,
      maxLevel: item?.maxLevel || 0,
      reorderLevel: item?.reorderLevel,
      salePrice: parseInt(formData?.salePrice),
      convToInvUOM: item?.convToInvUOM || 0,
    }));
    setAssets(item?.fixedAsset);
    setActive(item?.isActive);
  }, [location?.state, vat]); // eslint-disable-line

  useEffect(() => {
    const item = location.state;

    const selectedVat = vat?.find((v) => v.name === item?.vat);
    if (selectedVat) {
      setFormData((prevState) => ({
        ...prevState,
        Vat: { label: `${selectedVat?.name} ${selectedVat?.taxPercentage}%`, value: selectedVat?.taxPercentage },
      }));
    }

    const selectedPUM = packingUom?.find((p) => p?.description === item?.baseUnit);
    if (selectedPUM) {
      setFormData((prevState) => ({
        ...prevState,
        PackingUnitMeasurement: { label: selectedPUM?.description, value: selectedPUM },
      }));
    }

    const selectedPackingType = packingType?.find((pt) => pt?.description === item?.packingType);
    if (selectedPackingType) {
      setFormData((prevState) => ({
        ...prevState,
        PackingType: { label: selectedPackingType?.description, value: selectedPackingType },
      }));
    }

    const selectedSuplier = supplier?.find((sp) => sp?.record_Id === parseInt(item?.supplier));
    if (selectedSuplier) {
      const nameLabel = selectedSuplier?.supplierName || selectedSuplier?.name || '';
      const codeLabel = selectedSuplier?.supplierCode || selectedSuplier?.code || nameLabel;
      setFormData((prevState) => ({
        ...prevState,
        Supplier: { label: nameLabel, value: selectedSuplier },
        supplierName: { label: nameLabel, value: selectedSuplier },
        supplierCode: { label: codeLabel, value: selectedSuplier },
      }));
    }

    const selectedCategory = categoryOptions?.find((cat) => cat?.catName === item?.category);
    if (selectedCategory) {
      setFormData((prevState) => ({
        ...prevState,
        Category: { label: selectedCategory?.catName, value: selectedCategory },
      }));
    }

    const selectedSubCategory = subCategories?.find((cat) => cat?.subcatname === item?.subCategory);
    if (selectedSubCategory) {
      setFormData((prevState) => ({
        ...prevState,
        SubCategory: { label: selectedSubCategory?.subcatname, value: selectedSubCategory },
      }));
    }

    const selectedStocktype = stockType?.find((stock) => stock?.stockTypeCode === item?.stockType);
    if (selectedStocktype) {
      setFormData((prevState) => ({
        ...prevState,
        StockType: { label: selectedStocktype?.stockTypeName, value: selectedStocktype },
      }));
    }

    const selectedInvUOM = unitMeasurement?.find((InventoryUM) => InventoryUM?.description === item?.unitMeasurement);
    if (selectedInvUOM) {
      setFormData((prevState) => ({
        ...prevState,
        InventoryUom: { label: selectedInvUOM?.description, value: selectedInvUOM },
      }));
    }
  }, [vat, packingUom, packingType, supplier, categoryOptions, subCategories, stockType, unitMeasurement]); // eslint-disable-line

  useEffect(() => {
    if (formData.itemName && !isVariantEnabled && !formData.sku) {
      const autoSKU = generateMainItemSKU(formData.itemName);
      setFormData((prev) => ({
        ...prev,
        sku: autoSKU,
      }));
    }
  }, [formData.itemName, isVariantEnabled]);

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const apiService2 = new ApiService();
        const apiService = new ApiService2();
        let param2 = `?toPurchase=true`;
        let param = `?isActive=true`;

        const accountResponse = await apiService.get('GET_ACCOUNTS');
        setAccounts(accountResponse.data.result);

        const vat = await apiService.get('GET_TAX');
        setvat(vat.data?.result);

        const unitMeasurementResponse = await apiService.getApiParamater('GET_EUNIT_MEASUREMENT', param);
        setunitMeasurement(unitMeasurementResponse?.data?.result);

        const Supplier = await apiService.get('GET_SUPPLIER');
        setSupplier(Supplier?.data?.result);

        const packingResponse = await apiService.getApiParamater('GET_EPACKING', param);
        setPackingType(packingResponse?.data?.result);

        const stockType = await apiService.getApiParamater('GET_STOCK_TYPE', param);
        setStockType(stockType?.data?.result);

        const packingUOMResponse = await apiService.getApiParamater('GET_EUNIT_MEASUREMENT', param);
        setPackingUOMOptions(packingUOMResponse?.data?.result);

        try {
          const productTypesResponse = await apiService.getApiParamater('GET_PRODUCT_TYPES', param);
          setProductTypes(productTypesResponse?.data?.result || []);
        } catch {
          setProductTypes([]);
        }

        try {
          const brandsResponse = await apiService2.getApiParamater('GET_BRANDS', param);
          setBrands(brandsResponse?.data?.result || []);
        } catch {
          setBrands([]);
        }
      } catch (error) {
        console.error('Error fetching dropdown data:', error);
      }
    };
    fetchDropdownData();
  }, []);

  useEffect(() => {
    const retailPrice = parseFloat(formData.retailPrice) || 0;
    const taxPercentage = parseFloat(formData?.saleTax?.rate || formData?.saleTax?.value) || 0;

    if (retailPrice > 0) {
      const taxAmount = (taxPercentage / 100) * retailPrice;
      const totalRetail = retailPrice + taxAmount;

      setFormData((prev) => ({
        ...prev,
        TotalRetail: totalRetail.toFixed(2),
      }));
    }
  }, [formData.retailPrice, formData.saleTax]);

  const getVat = async () => {
    const vat = await apiService.get('GET_INV_TAX');
    setvat(vat.data.result);
  };

  const handleAddProduct = () => {
    if (selectedProduct && quantity > 0) {
      setProductsList([...productsList, { ...selectedProduct, quantity }]);
      setSelectedProduct(null);
      setQuantity(1);
    }
  };

  const handleRemoveProduct = (index) => {
    setProductsList(productsList.filter((_, i) => i !== index));
  };

  const handleInputChange = (e, selectedTax) => {
    const markup = parseFloat(formData.markup) || 0;
    const retailPrice = parseFloat(formData.retailPrice) || 0;
    const supplyPrice = parseFloat(formData.supplyPrice) || 0;

    if (selectedTax) {
      const taxPercentage = parseFloat(selectedTax.rate || selectedTax.value) || 0;
      const taxAmount = (taxPercentage / 100) * retailPrice;
      const totalRetail = retailPrice + taxAmount;

      const markupFactor = 1 + markup / 100;
      const newSupplyPrice = retailPrice / markupFactor;
      const markupValue = retailPrice - newSupplyPrice;

      setFormData((prevData) => ({
        ...prevData,
        saleTax: selectedTax,
        taxAmount: taxAmount.toFixed(2),
        TotalRetail: totalRetail.toFixed(2),
        markupValue: markupValue.toFixed(2),
      }));

      // Clear validation error for saleTax if it was previously invalid
      if (validationErrors.saleTax) {
        setValidationErrors((prev) => ({ ...prev, saleTax: '' }));
      }
      return;
    }

    const { name, value } = e.target;
    const taxPercentage = parseFloat(formData?.saleTax?.rate || formData?.saleTax?.value) || 0;

    // Clear validation error for this field
    if (validationErrors[name]) {
      setValidationErrors((prev) => ({ ...prev, [name]: '' }));
    }

    if (name === 'itemName') {
      updateAllSKUsOnItemNameChange(value);
    }

    if (name === 'sku' && !isVariantEnabled) {
      if (value === '') {
        const autoSKU = generateMainItemSKU(formData.itemName);
        setFormData((prev) => ({
          ...prev,
          sku: autoSKU,
        }));
        return;
      }
    }

    if (name === 'supplyPrice') {
      const markupValue = (markup / 100) * parseFloat(value || 0);
      const newRetailPrice = parseFloat(value || 0) + markupValue;
      const taxAmount = (taxPercentage / 100) * newRetailPrice;
      const totalRetail = newRetailPrice + taxAmount;

      setFormData((prev) => ({
        ...prev,
        supplyPrice: value,
        retailPrice: newRetailPrice.toFixed(2),
        TotalRetail: totalRetail.toFixed(2),
        markupValue: markupValue.toFixed(2),
        taxAmount: taxAmount.toFixed(2),
      }));
    } else if (name === 'markup') {
      const markupValue = (parseFloat(value || 0) / 100) * supplyPrice;
      const newRetailPrice = supplyPrice + markupValue;
      const taxAmount = (taxPercentage / 100) * newRetailPrice;
      const totalRetail = newRetailPrice + taxAmount;

      setFormData((prev) => ({
        ...prev,
        markup: value,
        retailPrice: newRetailPrice.toFixed(2),
        TotalRetail: totalRetail.toFixed(2),
        markupValue: markupValue.toFixed(2),
        taxAmount: taxAmount.toFixed(2),
      }));
    } else if (name === 'retailPrice') {
      const retailPriceValue = parseFloat(value || 0);

      let markupPerc = 0;
      let markupValue = 0;

      if (supplyPrice > 0 && retailPriceValue > supplyPrice) {
        markupValue = retailPriceValue - supplyPrice;
        markupPerc = (markupValue / supplyPrice) * 100;
      }

      const taxAmount = (taxPercentage / 100) * retailPriceValue;
      const totalRetail = retailPriceValue + taxAmount;

      setFormData((prev) => ({
        ...prev,
        retailPrice: value,
        markupValue: markupValue.toFixed(2),
        markup: markupPerc.toFixed(2),
        taxAmount: taxAmount.toFixed(2),
        TotalRetail: totalRetail.toFixed(2),
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  const handleWarehouseChange = (selectedOption) => {
    const wh = selectedOption?.value;
    setFormData((prev) => ({
      ...prev,
      warehouseLocation: selectedOption,
      warehouseLocationCode: wh?.locationCode?.toString() || wh?.whCode?.toString() || wh?.locationName || '',
    }));
  };
  const handleAddTag = () => {
    if (inputValue.trim() && !tags.includes(inputValue.trim())) {
      setTags([...tags, inputValue.trim()]);
      setInputValue('');
    }
  };

  const handleRemoveTag = (tagToRemove) => {
    setTags(tags.filter((tag) => tag !== tagToRemove));
  };

  const preventNegativeSign = (e) => {
    if (e.key === '-' || e.key === '+') {
      e.preventDefault();
    }
  };

  const handleToggle = () => {
    setIsVariantEnabled(!isVariantEnabled);
  };

  const handleActiveSelection = (e) => {
    setActive(e);
  };

  const toggleTracking = () => {
    setIsTracking(!isTracking);
  };

  const handleAttributeChange = (id, value) => {
    setAttributes((prev) => prev.map((attr) => (attr.id === id ? { ...attr, name: value } : attr)));
  };

  const handleValueChange = (id, event) => {
    if (event.key === ',' || event.key === 'Enter') {
      event.preventDefault();
      const newValue = event.target.value.trim();
      if (newValue !== '') {
        setAttributes((prev) => prev.map((attr) => (attr.id === id ? { ...attr, values: [...attr.values, newValue] } : attr)));
        event.target.value = '';
      }
    }
  };

  const removeValue = (attrId, valueToRemove) => {
    setAttributes((prev) => prev.map((attr) => (attr.id === attrId ? { ...attr, values: attr.values.filter((val) => val !== valueToRemove) } : attr)));
  };

  const addAttribute = () => {
    if (attributes.length < 3) {
      setAttributes([...attributes, { id: Date.now(), name: '', values: [] }]);
    }
  };

  const removeAttribute = (id) => {
    setAttributes(attributes.filter((attr) => attr.id !== id));
  };

  const generateSKU = (itemName, variantName, index) => {
    const itemPrefix = itemName ? itemName.substring(0, 3).toUpperCase() : 'ITM';
    const variantPrefix = variantName ? variantName.substring(0, 2).toUpperCase() : 'VAR';
    const paddedIndex = String(index + 1).padStart(4, '0');
    return `${itemPrefix}-${variantPrefix}-${paddedIndex}`;
  };

  const generateMainItemSKU = (itemName) => {
    const itemPrefix = itemName ? itemName.substring(0, 6).toUpperCase() : 'ITEM';
    const timestamp = Date.now().toString().slice(-6);
    return `${itemPrefix}-${timestamp}`;
  };

  const generateVariants = () => {
    let newVariants = attributes.reduce((acc, attr) => {
      if (acc.length === 0) return attr.values.map((value) => [value]);
      return acc.flatMap((existing) => attr.values.map((value) => [...existing, value]));
    }, []);

    const formattedVariants = newVariants.map((variant, index) => {
      const taxPercent = Number(formData?.saleTax?.rate || formData?.saleTax?.value || 0);

      // ✅ default variant retail price = parent retail price
      const retailPrice = Number(formData?.retailPrice || 0);
      const taxAmount = (retailPrice * taxPercent) / 100;
      const totalRetailPrice = retailPrice + taxAmount;

      const variantName = variant.join(' / ');
      const autoGeneratedSKU = generateSKU(formData.itemName, variantName, index);

      return {
        name: variantName,
        sku: autoGeneratedSKU,
        barcode: '', // ✅ new field per variant
        supplierCode: '',
        customLoyalty: '',
        retailPrice: retailPrice.toFixed(2),
        tax: taxAmount.toFixed(2),
        totalRetailPrice: totalRetailPrice.toFixed(2),
      };
    });

    setVariants((prev) => [...prev, ...formattedVariants]);
    setAttributes([]);
  };

  const removeVariant = (index) => {
    setVariants((prev) => prev.filter((_, i) => i !== index));
  };

  const handleChange = (index, field, value) => {
    setVariants((prev) =>
      prev.map((variant, i) => {
        if (i !== index) return variant;

        // ✅ barcode edit
        if (field === 'barcode') {
          return { ...variant, barcode: value };
        }

        if (field === 'name') {
          const newSKU = generateSKU(formData.itemName, value, index);
          return { ...variant, name: value, sku: newSKU };
        }

        // ✅ retail price override (only)
        if (field === 'retailPrice') {
          const retailPrice = Number(value || 0);
          const taxPercent = Number(formData?.saleTax?.rate || formData?.saleTax?.value || 0);
          const taxAmount = (retailPrice * taxPercent) / 100;
          const totalRetailPrice = retailPrice + taxAmount;

          return {
            ...variant,
            retailPrice: retailPrice.toFixed(2),
            tax: taxAmount.toFixed(2),
            totalRetailPrice: totalRetailPrice.toFixed(2),
          };
        }

        return { ...variant, [field]: value };
      }),
    );
  };

  const updateAllSKUsOnItemNameChange = (newItemName) => {
    if (variants.length > 0) {
      setVariants((prev) =>
        prev.map((variant, index) => ({
          ...variant,
          sku: generateSKU(newItemName, variant.name, index),
        })),
      );
    }
  };

  const handleSupplier = (selectedOption) => {
    const supObj = selectedOption?.value;
    const nameLabel = supObj?.supplierName || supObj?.name || '';
    const codeLabel = supObj?.accountCode || supObj?.code || nameLabel;

    setFormData((prev) => ({
      ...prev,
      supplierName: { value: supObj, label: nameLabel },
      supplierCode: { value: supObj, label: codeLabel },
    }));
  };

  // Validation function
  const validateForm = () => {
    const errors = {};

    // Item Description - Required
    if (!formData.itemDescription || formData.itemDescription.trim() === '') {
      errors.itemDescription = 'Item Description is required';
    }

    // Category - Required
    if (!formData.category || !formData.category.label) {
      errors.category = 'Category is required';
    }

    // SubCategory - Required
    if (!formData.subCategory || !formData.subCategory.label) {
      errors.subCategory = 'SubCategory is required';
    }

    // VAT (Sales Tax) - Required
    if (!formData.saleTax || !formData.saleTax.label) {
      errors.saleTax = 'VAT/Sales Tax is required';
    }

    // Inventory UOM - Required
    if (!formData.inventoryUom || !formData.inventoryUom.label) {
      errors.inventoryUom = 'Inventory UOM is required';
    }

    // Packing Type - Required
    if (!formData.packingType || !formData.packingType.label) {
      errors.packingType = 'Packing Type is required';
    }

    // Packing UOM - Required
    if (!formData.packingUOM || !formData.packingUOM.label) {
      errors.packingUOM = 'Packing UOM is required';
    }

    // Conversion Rate - Required and must be >= 1
    if (!formData.ConversitionRate || formData.ConversitionRate === '') {
      errors.ConversitionRate = 'Conversion Rate is required';
    } else if (parseFloat(formData.ConversitionRate) < 1) {
      errors.ConversitionRate = 'Conversion Rate must be at least 1';
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const CreateItem = async () => {
    // Validate form before submission
    if (!validateForm()) {
      console.log('Formdataa', formData);
      toast.error('Please fill in all required fields');
      const firstErrorField = Object.keys(validationErrors)[0];
      const element = document.getElementsByName(firstErrorField)[0];
      if (element) element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (variants.length > 0) {
      const missing = variants.find((v) => !v.barcode || String(v.barcode).trim() === '');
      if (missing) {
        toast.error('Please enter barcode for all variants');
        return;
      }
    }

    setLoader(true);

    // ---- helpers: price normalization ----
    const clampNumber = (n) => (Number.isFinite(n) ? n : 0);
    const round2 = (n) => Number(clampNumber(n).toFixed(2));
    const fromNet = (net, r) => {
      const tax = net * (r / 100);
      const gross = net + tax;
      return { net: round2(net), tax: round2(tax), gross: round2(gross) };
    };
    const fromGross = (gross, r) => {
      const net = gross / (1 + r / 100);
      const tax = gross - net;
      return { net: round2(net), tax: round2(tax), gross: round2(gross) };
    };
    const resolveRetail = (retailInput, rate, mode /* 'IMPLICIT'|'EXPLICIT' */) => {
      const retail = clampNumber(parseFloat(retailInput) || 0);
      const r = clampNumber(parseFloat(rate) || 0);
      return mode === 'IMPLICIT' ? fromGross(retail, r) : fromNet(retail, r);
    };

    try {
      const currentDatetimeUTC = new Date().toISOString();
      const taxMode = taxImplicit ? 'IMPLICIT' : 'EXPLICIT';
      const taxRate = parseFloat(formData?.saleTax?.rate || formData?.saleTax?.value) || 0;

      // Normalize the "main" retail numbers from the current UI value
      const mainResolved = resolveRetail(formData.retailPrice, taxRate, taxMode);
      const mainSupply = parseFloat(formData.supplyPrice || 0);

      // Build variants source (use your existing array if provided, otherwise synthesize one from main form)
      const baseVariants =
        variants.length > 0
          ? variants
          : [
              {
                name: formData.itemName,
                sku: formData.sku,
                supplierCode: formData.supplierCode?.label || '',
                customLoyalty: '',
                supplyPrice: parseFloat(formData.supplyPrice || 0),
                markup: parseFloat(formData.markup || 0),
                // NOTE: This value could be net or gross depending on the UI mode.
                // We'll normalize below via resolveRetail so API gets both forms correctly.
                retailPrice: parseFloat(formData.retailPrice || 0),
              },
            ];

      // Normalize each variant's pricing according to current tax mode
      const normalizedVariants = baseVariants.map((v) => {
        const vSupply = parseFloat(v.supplyPrice || 0);
        const vRetailInput = parseFloat(v.retailPrice || 0);

        const res = resolveRetail(vRetailInput, taxRate, taxMode); // -> {net, tax, gross}

        // derive/confirm "display" fields consistently
        return {
          ...v,
          // Keep original fields if API/UI expects them,
          // but also attach canonical normalized fields:
          retailPriceNet: res.net,
          retailPriceGross: res.gross,
          taxAmount: res.tax,
          supplyPrice: vSupply,
        };
      });

      // Build itemMasterDetails with normalized pricing
      const itemMasterDetails = normalizedVariants.map((item, index) => {
        const namePrefix = item?.name ? item.name.substring(0, 2).toUpperCase() : 'XX';
        const timestamp = Date.now().toString().slice(-6);
        const randomSuffix = Math.floor(Math.random() * 1000)
          .toString()
          .padStart(3, '0');
        const paddedIndex = String(index + 1).padStart(3, '0');
        const uniqueItemNo = `${namePrefix}-${timestamp}-${paddedIndex}-${randomSuffix}`;

        const supplierCodeStr =
          formData?.supplierCode?.value?.supplier_ID ||
          formData?.supplierCode ||
          item?.supplierCode ||
          formData?.supplierName?.value?.supplierCode ||
          formData?.supplierName?.value?.code ||
          '';

        const supplierNameStr =
          formData?.supplierName?.label || formData?.supplierName || formData?.supplierCode?.value?.supplierName || formData?.supplierCode?.value?.name || '';

        return {
          itemNo: uniqueItemNo,
          itemDescription: variants.length > 0 ? `${formData.itemName}/${item?.name}` : formData.itemName,
          stock: 50,
          brand: formData?.brandName?.label,
          supplier: supplierCodeStr,
          warehouseLocation: formData?.warehouseLocation?.label || '',
          exp1: item?.customLoyalty,
          exp2: (item?.markup ?? formData?.markup ?? 0).toString(),
          // If exp3 is meant to be the display "retail price", choose a consistent form.
          // Commonly, downstream wants the *final* price (incl. tax):
          exp3: item.retailPriceGross.toString(),
          exp4: item?.sku,
          exp5: supplierNameStr,
          barcode: item?.barcode || '',
          parentSku: formData?.sku, // ✅ optional but helpful for parent-child linkage
          inventory: 'true',
          exp9: '1',
          // IMPORTANT: Use normalized prices here:
          salePrice: item.retailPriceGross, // Incl. tax (customer-facing)
          salePriceExclTax: item.retailPriceNet, // Add this extra field if your API accepts it (very useful!)
          taxAmount: item.taxAmount, // Per-unit tax at current rate
          taxRate: taxRate,
          purchaseUnit: formData?.purchaseUnit || 0,
          SaleUnit: formData?.SaleUnit || 0,

          purchasePrice: parseFloat(item?.supplyPrice || 0), // Supply price (usually excl. tax)

          vat: formData?.saleTax?.description || formData?.saleTax?.label || '',
          modifiedOn: currentDatetimeUTC,
          createdOn: currentDatetimeUTC,
          supplierName: supplierNameStr,
          category: formData?.category?.value?.catCode,
          subcategory: formData?.subCategory?.value?.subcatcode,
          inventoryUOM: formData?.inventoryUom?.label,
          packingType: formData?.packingType?.label,
          baseUnit: formData?.packingUOM?.label,
        };
      });

      // Top-level normalized values (handy for detail screens / list views)
      const userData = {
        itemName: formData.itemName,
        description: formData?.itemDescription,
        brand: formData?.brandName?.label,
        modelNumber: '',
        barcode: formData?.barcode,

        // IMPORTANT: send *both* excl & incl (if your API allows)
        retailPrice: mainResolved.gross, // prefer final price incl. tax
        retailPriceExclTax: mainResolved.net, // helpful for reporting
        retailPriceInclTax: mainResolved.gross, // explicit alias
        taxAmount: mainResolved.tax,
        taxRate: taxRate,
        taxDescription: formData?.saleTax?.description || formData?.saleTax?.label || '',
        taxMode: taxMode, // 'IMPLICIT' | 'EXPLICIT' (optional but useful)

        wholesalePrice: mainSupply, // supply price (excl. tax)
        costPrice: parseFloat(formData?.markup || 0), // if your API uses this differently, adjust

        discountPrice: 0,
        priceHistory: '',
        currency: '',

        stockQuantity: '',
        minStockLevel: 0,
        maxStockLevel: 0,
        restockDate: currentDatetimeUTC,

        supplierVendor: formData?.supplierName?.label,
        locationWarehouse: formData?.warehouseLocation?.label || '',

        weight: parseInt(formData?.Weight || 0),
        length: parseInt(formData?.Length || 0),
        width: parseInt(formData?.Width || 0),
        height: parseInt(formData?.Height || 0),
        volume: parseInt(formData?.Volume || 0),

        productImage: 'https://example.com/images/headphone.jpg',
        additionalImages: 'https://example.com/images/headphone-side.jpg, https://example.com/images/headphone-box.jpg',

        color: '',
        material: '',
        style: '',
        finish: '',
        supplierName: formData?.supplierName?.label,

        manufacturerName: '',
        manufacturerPartNumber: '',
        leadTime: currentDatetimeUTC,
        saleStartDate: currentDatetimeUTC,
        saleEndDate: currentDatetimeUTC,
        promotionCodes: '',
        specialOffers: '',
        shippingWeight: 0,
        shippingDimensions: '',
        shippingClass: '',
        shippingMethod: '',
        shippingRestrictions: '',
        ratingReviews: '',
        warrantyInformation: '',
        returnPolicy: '',
        expirationDate: currentDatetimeUTC,
        availabilityStatus: '',
        itemStatus: true,

        itemMasterDetails: itemMasterDetails,

        category: formData?.category?.value?.catCode,
        subcategory: formData?.subCategory?.value?.subcatcode,
        productTags: '',
        inventoryUOM: formData?.inventoryUom?.label,
        packingType: formData?.packingType?.label,
        thickness: formData?.Thickness || 0,
        reorderLevel: formData?.ReorderLevel || 0,
        maxQTY: formData?.MaxQTY || 0,
        minQTY: formData?.MinQTY || 0,
        shape: formData?.Shape || '',
        hasVariants: variants.length > 0,
        ConversitionRate: Number(formData?.ConversitionRate || 1),
      };

      // Send!
      const response = await apiService.post('CREATE_ITEM_MASTER', userData);

      if (response?.data?.statusCode === 201) {
        setLoader(false);
        toast.success(`${formData.itemName} Created successfully`);
        navigate('/admin/menu');
      } else {
        setLoader(false);
        toast?.warning(response?.data?.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error('Error Creating Item:', error);
      toast.error('Failed to create item. Please try again.');
    }
  };

  const handleProductType = (selectedOption) => {
    setFormData({ ...formData, productType: selectedOption });
  };

  const handleBrand = (selectedOption) => {
    setFormData({ ...formData, brandName: selectedOption });
  };

  const handleBackClick = () => {
    window.history.back();
  };

  const handlePackingUOMChange = (selectedOption) => {
    setFormData({ ...formData, packingUOM: selectedOption });
    // Clear validation error
    if (validationErrors.packingUOM) {
      setValidationErrors((prev) => ({ ...prev, packingUOM: '' }));
    }
  };

  const handleInventoryUOmChange = (selectedOption) => {
    setFormData({ ...formData, inventoryUom: selectedOption });
    // Clear validation error
    if (validationErrors.inventoryUom) {
      setValidationErrors((prev) => ({ ...prev, inventoryUom: '' }));
    }
  };

  const handlePackingTypeChange = (selectedOption) => {
    setFormData({ ...formData, packingType: selectedOption });
    // Clear validation error
    if (validationErrors.packingType) {
      setValidationErrors((prev) => ({ ...prev, packingType: '' }));
    }
  };

  const handleSubcat = async (selectedOption) => {
    try {
      let param = `?Catcode=${selectedOption?.value?.catCode}`;
      const subCategoryResponse = await apiService.getApiParamater('GET_SUB_CATEGORY_MASTER', param);
      const subCategoryOptions = subCategoryResponse?.data?.result;
      setSubCategoryOptions(subCategoryOptions);
    } catch (error) {
      console.error('Error fetching subcategories:', error);
      setSubCategoryOptions([]);
    }
  };

  const handleCategoryChange = (selectedOption) => {
    setFormData({
      ...formData,
      category: selectedOption,
      subCategory: [],
    });
    handleSubcat(selectedOption);
    // Clear validation error
    if (validationErrors.category) {
      setValidationErrors((prev) => ({ ...prev, category: '' }));
    }
  };

  const handleSubCategoryChange = (selectedOption) => {
    setFormData({
      ...formData,
      subCategory: selectedOption,
    });
    // Clear validation error
    if (validationErrors.subCategory) {
      setValidationErrors((prev) => ({ ...prev, subCategory: '' }));
    }
  };

  const MainItemSKUField = () => (
    <div className="col mt-3">
      <label htmlFor="validationCustom04" className="form-label">
        Stock Keeping Unit ( SKU )<small className="text-muted ms-2">Auto-generated based on item name</small>
      </label>
      <div className="input-group">
        <input
          type="text"
          className="form-control"
          name="sku"
          value={formData.sku}
          placeholder="Auto-generated SKU"
          onChange={handleInputChange}
          style={{ backgroundColor: '#f8f9fa' }}
          title="Auto-generated SKU. Click to edit if needed."
        />
        <button
          className="btn btn-outline-secondary"
          type="button"
          onClick={() => {
            const newSKU = generateMainItemSKU(formData.itemName);
            setFormData((prev) => ({ ...prev, sku: newSKU }));
          }}
          title="Regenerate SKU"
        >
          🔄
        </button>
      </div>
    </div>
  );

  return (
    <div className="p-4">
      <button className="addItem-btn mb-3" onClick={() => navigate(-1)}>
        ← Back
      </button>
      <div className="d-flex justify-content-between pt-3">
        <h5 className="col mainInvHead">Item Master</h5>
        <div className="d-flex gap-3">
          {loader === true ? (
            <button className="mainbtn " type="submit">
              <ClipLoader color="#ffffff" size={25} />
            </button>
          ) : (
            <button className="mainbtn " type="submit" onClick={CreateItem}>
              <FaSave className="center mt-1 mx-2" />
              <div>Save</div>
            </button>
          )}
          <button onClick={handleBackClick} className="mainbtnSecondary">
            <FaAngleLeft className="center mt-1 mx-2" />
            <div>Back</div>
          </button>
        </div>
      </div>
      <div className="cost-center-section">
        <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setItemTab(!itemDetaillsTab)}>
          <div className="h6 pt-1">Product Details</div>
        </div>
        <div className={`slide-content ${itemDetaillsTab ? 'open' : 'closed'}`}>
          <div className="border-box2 p-3">
            <div className="form-group row pb-3">
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  Item Name{' '}
                </label>
                <input
                  type="text"
                  className="p-2 form-control"
                  name="itemName"
                  value={formData.itemName}
                  placeholder="Enter Item Name"
                  onChange={handleInputChange}
                />
              </div>
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  Description <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`p-2 form-control ${validationErrors.itemDescription ? 'is-invalid' : ''}`}
                  name="itemDescription"
                  value={formData.itemDescription}
                  placeholder="Enter Description"
                  onChange={handleInputChange}
                />
                {validationErrors.itemDescription && <div className="invalid-feedback">{validationErrors.itemDescription}</div>}
              </div>
            </div>
            <div className="form-group row pb-3">
              <div className="col">
                <label htmlFor="tagInput" className="form-label">
                  Product Tags
                </label>
                <input
                  type="text"
                  className="p-2 form-control"
                  id="tagInput"
                  name="tags"
                  value={inputValue}
                  placeholder="Enter Tag"
                  onChange={(e) => setInputValue(e.target.value)}
                />
              </div>
              <div className="col">
                <label htmlFor="tagInput" className="form-label"></label>
                <button className="btn p-3 btn-primary w-100 " onClick={handleAddTag}>
                  Add
                </button>
              </div>
            </div>
            <div className="mt-2 pb-3">
              {tags.map((tag, index) => (
                <span key={index} className="badge bg-secondary mt-1 me-2">
                  {tag}{' '}
                  <button className="btn btn-sm btn-danger ms-3" onClick={() => handleRemoveTag(tag)}>
                    X
                  </button>
                </span>
              ))}
            </div>

            <div className="form-group row pb-3">
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  Select Supplier (Name)
                </label>
                <Select
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  menuPortalTarget={document.body}
                  value={formData.supplierName}
                  onChange={(selectedOption) => handleSupplier(selectedOption)}
                  options={supplier?.map((sup) => ({
                    value: sup,
                    label: sup?.supplierName || sup?.name,
                  }))}
                  placeholder="Select Supplier"
                />
              </div>

              <div className="col">
                <label htmlFor="validationCustom04" className="form-label">
                  Product Type
                </label>
                <Select
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  menuPortalTarget={document.body}
                  value={formData.productType}
                  onChange={(selectedOption) => setFormData({ ...formData, productType: selectedOption })}
                  options={productTypes?.map((type) => ({
                    value: type,
                    label: type?.typeName || type?.name || type?.description,
                  }))}
                  placeholder="Select Product Type"
                />
              </div>

              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  Product Brand
                </label>
                <Select
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  menuPortalTarget={document.body}
                  value={formData.brandName}
                  onChange={(selectedOption) => setFormData({ ...formData, brandName: selectedOption })}
                  options={brands?.map((brand) => ({
                    value: brand,
                    label: brand?.brandName || brand?.name,
                  }))}
                  placeholder="Select Brand"
                />
              </div>
            </div>

            <div className="form-group row pb-3">
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  Supplier Code
                </label>
                <Select
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  isDisabled
                  menuPortalTarget={document.body}
                  value={formData.supplierCode}
                  onChange={() => {}}
                  options={supplier?.map((sup) => ({
                    value: sup,
                    label: sup?.supplierCode || sup?.code || sup?.supplierName,
                  }))}
                  placeholder="Supplier Code"
                />
              </div>

              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  Sales Account Code
                </label>
                <input
                  type="text"
                  className="p-2 form-control"
                  name="saleAccount"
                  value={formData.saleAccount}
                  placeholder="Enter Sale Account"
                  onChange={handleInputChange}
                />
              </div>
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  Purchase Account Code
                </label>
                <input
                  type="text"
                  className="p-2 form-control"
                  name="PurchaseAccount"
                  value={formData.PurchaseAccount}
                  placeholder="Enter Purchase Account"
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="form-group row pb-3">
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  Category <span className="text-danger">*</span>
                </label>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({
                      ...base,
                      borderColor: validationErrors.category ? '#dc3545' : base.borderColor,
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="p-0"
                  value={formData?.category}
                  onChange={(selectedOption) => handleCategoryChange(selectedOption)}
                  options={categoryOptions?.map((CatOpt) => ({
                    value: CatOpt,
                    label: CatOpt?.catName,
                  }))}
                  placeholder="Select Category"
                />
                {validationErrors.category && <div className="text-danger small mt-1">{validationErrors.category}</div>}
              </div>
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  Sub Category <span className="text-danger">*</span>
                </label>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({
                      ...base,
                      borderColor: validationErrors.subCategory ? '#dc3545' : base.borderColor,
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="p-0"
                  value={formData?.subCategory}
                  onChange={(selectedOption) => handleSubCategoryChange(selectedOption)}
                  options={subCategoryOptions?.map((SubCatOpt) => ({
                    value: SubCatOpt,
                    label: SubCatOpt?.subcatname,
                  }))}
                  placeholder="Select Sub Category"
                />
                {validationErrors.subCategory && <div className="text-danger small mt-1">{validationErrors.subCategory}</div>}
              </div>
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  Inventory UOM <span className="text-danger">*</span>
                </label>
                <Select
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({
                      ...base,
                      borderColor: validationErrors.inventoryUom ? '#dc3545' : base.borderColor,
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  menuPortalTarget={document.body}
                  value={formData.inventoryUom}
                  onChange={handleInventoryUOmChange}
                  options={unitMeasurement?.map((unit) => ({
                    value: unit,
                    label: unit?.description,
                  }))}
                  placeholder="Select Inventory UOM"
                />
                {validationErrors.inventoryUom && <div className="text-danger small mt-1">{validationErrors.inventoryUom}</div>}
              </div>
            </div>

            <div className="form-group row pb-3">
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  Packing type <span className="text-danger">*</span>
                </label>
                <Select
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({
                      ...base,
                      borderColor: validationErrors.packingType ? '#dc3545' : base.borderColor,
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  menuPortalTarget={document.body}
                  value={formData.packingType}
                  onChange={handlePackingTypeChange}
                  options={packingType?.map((pack) => ({
                    value: pack,
                    label: pack?.description,
                  }))}
                  placeholder="Select Packing Type"
                />
                {validationErrors.packingType && <div className="text-danger small mt-1">{validationErrors.packingType}</div>}
              </div>
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  packing UOM <span className="text-danger">*</span>
                </label>
                <Select
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({
                      ...base,
                      borderColor: validationErrors.packingUOM ? '#dc3545' : base.borderColor,
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  menuPortalTarget={document.body}
                  value={formData.packingUOM}
                  onChange={handlePackingUOMChange}
                  options={packingUom?.map((pack) => ({
                    value: pack,
                    label: pack?.description,
                  }))}
                  placeholder="Select Packing UOM"
                />
                {validationErrors.packingUOM && <div className="text-danger small mt-1">{validationErrors.packingUOM}</div>}
              </div>
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  Volume
                </label>
                <input type="text" className="p-2 form-control" name="Volume" value={formData.Volume} placeholder="Enter Volume" onChange={handleInputChange} />
              </div>
            </div>

            <div className="form-group row pb-3">
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  Thickness
                </label>
                <input
                  type="text"
                  className="p-2 form-control"
                  name="Thickness"
                  value={formData.Thickness}
                  placeholder="Enter Thickness"
                  onChange={handleInputChange}
                />
              </div>
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  Reorder Level
                </label>
                <input
                  type="text"
                  className="p-2 form-control"
                  name="ReorderLevel"
                  value={formData.ReorderLevel}
                  placeholder="Enter Reorder Level"
                  onChange={handleInputChange}
                />
              </div>
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  Max QTY
                </label>
                <input
                  type="text"
                  className="p-2 form-control"
                  name="MaxQTY"
                  value={formData.MaxQTY}
                  placeholder="Enter Max QTY"
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="form-group row pb-3">
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  Width
                </label>
                <input type="text" className="p-2 form-control" name="Width" value={formData.Width} placeholder="Enter Width" onChange={handleInputChange} />
              </div>
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  Length
                </label>
                <input type="text" className="p-2 form-control" name="Length" value={formData.Length} placeholder="Enter Length" onChange={handleInputChange} />
              </div>
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  Min QTY
                </label>
                <input
                  type="number"
                  className="p-2 form-control"
                  name="MinQTY"
                  value={formData.MinQTY}
                  placeholder="Enter Min QTY"
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="form-group row pb-3">
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  Height
                </label>
                <input type="text" className="p-2 form-control" name="Height" value={formData.Height} placeholder="Enter Height" onChange={handleInputChange} />
              </div>
              <div className="col-4">
                <label htmlFor="validationCustom01" className="form-label">
                  Weight
                </label>
                <input type="text" className="p-2 form-control" name="Weight" value={formData.Weight} placeholder="Enter Weight" onChange={handleInputChange} />
              </div>
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  Shape
                </label>
                <input type="text" className="p-2 form-control" name="Shape" value={formData.Shape} placeholder="Enter Shape" onChange={handleInputChange} />
              </div>
            </div>

            <div className="form-group row">
              <div className="col-4">
                <label htmlFor="validationCustom01" className="form-label">
                  Bar Code
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="barcode"
                  name="barcode"
                  placeholder={variants.length > 0 ? 'Use variant barcodes below' : 'BarCode'}
                  value={formData?.barcode}
                  onChange={handleInputChange}
                  disabled={variants.length > 0}
                />
              </div>
              <div className="col-4">
                <label htmlFor="ConversitionRate" className="form-label">
                  Conversion Rate <span className="text-danger">*</span>
                  <small className="text-muted ms-2">(default 1)</small>
                </label>
                <input
                  id="ConversitionRate"
                  type="number"
                  className={`p-2 form-control ${validationErrors.ConversitionRate ? 'is-invalid' : ''}`}
                  name="ConversitionRate"
                  min="1"
                  step="any"
                  value={formData.ConversitionRate}
                  placeholder="1"
                  onWheel={(e) => e.target.blur()}
                  onKeyDown={preventNegativeSign}
                  onChange={handleInputChange}
                  title="How many packing/base units make 1 inventory unit"
                />
                {validationErrors.ConversitionRate && <div className="invalid-feedback">{validationErrors.ConversitionRate}</div>}
              </div>
              {/* After the existing Barcode + ConversitionRate row, add: */}
              {/* <div className="form-group row pb-3 mt-3"> */}
              <div className="col-4">
                <label htmlFor="warehouseLocation" className="form-label">
                  Warehouse Location
                </label>
                <Select
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5' : null,
                      color: '#000',
                      ':hover': { backgroundColor: '#F5F5F5', color: '#000' },
                    }),
                  }}
                  menuPortalTarget={document.body}
                  value={formData.warehouseLocation}
                  onChange={handleWarehouseChange}
                  options={warehouseOptions?.map((wh) => ({
                    value: wh,
                    label: wh?.locationName ?? wh?.description ?? wh?.whCode ?? '',
                  }))}
                  placeholder="Select Warehouse Location"
                  isClearable
                />
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="cost-center-section">
        <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setPriceTab(!priceTab)}>
          <div className="h6 pt-1">Pricing Details</div>
        </div>
        <div className={`slide-content ${priceTab ? 'open' : 'closed'}`}>
          <div className="border-box2 p-3">
            <div className="form-group row">
              <div className="col">
                <label htmlFor="validationCustom04" className="form-label">
                  Supply Price
                </label>
                <input
                  type="number"
                  className="p-2 form-control"
                  name="supplyPrice"
                  value={formData.supplyPrice}
                  placeholder="0.00"
                  onWheel={(e) => e.target.blur()}
                  onChange={handleInputChange}
                  onKeyDown={preventNegativeSign}
                />
                <label htmlFor="validationCustom04" className="form-label"></label>
              </div>
              {/* <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  {' '}
                  + Markup ( % ){' '}
                </label>
                <input
                  type="number"
                  className="p-2 form-control"
                  name="markup"
                  value={formData.markup}
                  placeholder="0.00"
                  onWheel={(e) => e.target.blur()}
                  onChange={handleInputChange}
                  onKeyDown={preventNegativeSign}
                />
              </div> */}
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  = Retail Price
                </label>
                <input
                  type="number"
                  className="p-2 form-control"
                  name="retailPrice"
                  value={formData.retailPrice}
                  placeholder="0.00"
                  onWheel={(e) => e.target.blur()}
                  onChange={handleInputChange}
                  onKeyDown={preventNegativeSign}
                />
                <label htmlFor="validationCustom04" className="form-label">
                  ( Excluding Tax )
                </label>
              </div>
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  + Sales Tax <span className="text-danger">*</span>
                </label>
                <Select
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    control: (base) => ({
                      ...base,
                      borderColor: validationErrors.saleTax ? '#dc3545' : base.borderColor,
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  menuPortalTarget={document.body}
                  value={formData?.saleTax}
                  options={vat?.map((tax) => ({
                    value: tax?.rate,
                    label: `${tax?.description} ${tax?.rate}%`,
                    description: tax?.description,
                    rate: tax?.rate,
                  }))}
                  onChange={(selectedOption) => handleInputChange(null, selectedOption)}
                  placeholder="Select Tax"
                />
                {validationErrors.saleTax && <div className="text-danger small mt-1">{validationErrors.saleTax}</div>}
              </div>
              <div className="col">
                <label htmlFor="validationCustom01" className="form-label">
                  = Retail Price
                </label>
                <input type="number" className="p-2 form-control" name="TotalRetail" value={formData.TotalRetail} readOnly placeholder="0.00" />
                <label htmlFor="validationCustom04" className="form-label">
                  {' '}
                  ( Including Tax )
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="cost-center-section">
        <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setLoyalityTag(!loyaltyTag)}>
          <div className="h6 pt-1">Loyalty </div>
        </div>
        <div className={`slide-content ${loyaltyTag ? 'open' : 'closed'}`}>
          <div className="border-box2 p-3">
            <div className="card-header">
              <p>
                You can override the default Loyalty earned when purchasing this product. Please note that custom Loyalty values will not update if you edit the
                product's price on the sell screen.
              </p>
            </div>
            <div className="d-flex gap-5">
              <h5 className="pt-3">Purchasing Earns</h5>
              <div className="">
                <div className="d-flex gap-5">
                  <input type="radio" id="loyalty" name="loyalty" style={{ width: '20px', height: '20px' }} />
                  <label htmlFor="loyalty" className="form-check-label">
                    0.00 Loyalty ( based on the default Loyalty ratio of 100 : 1 )
                  </label>
                </div>
                <div className="d-flex gap-5 mt-3">
                  <input type="radio" id="customloyalty" name="customloyalty" style={{ width: '20px', height: '20px' }} />
                  <label htmlFor="customloyalty" className="form-check-label">
                    A custom Loyalty of{' '}
                  </label>
                  <input type="number" placeholder="0.00"></input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="cost-center-section">
        <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setProductTag(!productTypeTag)}>
          <div className="h6 pt-1">Product Type & Inventory </div>
        </div>
        <div className={`slide-content ${productTypeTag ? 'open' : 'closed'}`}>
          <div className="border-box2 p-5">
            <div className="row d-flex justify-content-between">
              <div className={`col p-5 orngbox center gap-4 ${selectedType === 'Standard' ? 'selected-box' : ''}`} onClick={() => setSelectedType('Standard')}>
                <PiTagFill size={25} />
                <h5 className="mt-1">Standard</h5>
              </div>
            </div>
            {selectedType === 'Standard' ? (
              <>
                <div className="form-group row">
                  <div className="col mt-3">
                    <label htmlFor="validationCustom04" className="form-label">
                      Stock Keeping Unit ( SKU )
                    </label>
                    <input
                      type="text"
                      className="p-2 form-control"
                      name="sku"
                      value={formData.sku}
                      placeholder="Auto-generated SKU"
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="row my-4  d-flex justify-content-between">
                  <div className="col-5">
                    <h5>Variant Product</h5>
                    <p>
                      These are products that have different versions, like size or color. Turn this on to specify up to three attributes (like color), and
                      unlimited values for each attribute (like green, blue, black).
                    </p>
                  </div>
                  <div className="col-5">
                    <h5>This Product has Variant </h5>
                    <div className="form-check form-switch mt-2">
                      <input
                        style={{ width: '80px', height: '40px' }}
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="attributeSwitch"
                        onChange={handleToggle}
                      />
                    </div>
                  </div>
                </div>
                <div className="row my-4  d-flex justify-content-between">
                  <div className="col-5">
                    <h5>Tracking Inventory</h5>
                    <p>
                      Turn this on if you want to keep track of your inventory quantities. You'll be able to report on cost of goods sold, product performance,
                      and projected weeks cover, as well as manage your store using inventory orders, transfers and rolling inventory counts.
                    </p>
                  </div>
                  <div className="col-5">
                    <h5>Track Inventory with Vend</h5>
                    <div className="form-check form-switch mt-2">
                      <input
                        style={{ width: '80px', height: '40px' }}
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="veriants"
                        checked={isTracking}
                        onChange={toggleTracking}
                      />
                    </div>
                  </div>
                </div>
                {isVariantEnabled && (
                  <div className="col-12 mt-4">
                    {attributes.map((attr, index) => (
                      <div key={attr.id} className="row align-items-center mb-3">
                        <div className="col-3">
                          <select className="form-select" value={attr.name} onChange={(e) => handleAttributeChange(attr.id, e.target.value)}>
                            <option value="">Select Attribute</option>
                            {index === 0 && <option value="Color">Color</option>}
                            {index === 1 && <option value="Size">Size</option>}
                            {index === 2 && <option value="Material">Material</option>}
                          </select>
                        </div>
                        <div className="col-8">
                          <div className="border p-2 rounded">
                            {attr.values.map((val, index) => (
                              <span key={index} className="badge bg-primary m-1 p-2">
                                {val} <FaTimes className="ms-1 cursor-pointer" onClick={() => removeValue(attr.id, val)} style={{ cursor: 'pointer' }} />
                              </span>
                            ))}
                            <input
                              type="text"
                              className="form-control border-0 d-inline w-25 mt-2"
                              placeholder="Type and press comma or Enter"
                              onKeyDown={(event) => handleValueChange(attr.id, event)}
                            />
                          </div>
                        </div>
                        <div className="col-1">
                          <button className="btn btn-danger" onClick={() => removeAttribute(attr.id)}>
                            <FaTrash />
                          </button>
                        </div>
                      </div>
                    ))}
                    {attributes.length < 3 && (
                      <button className="btn btn-primary" onClick={addAttribute}>
                        + Add Attribute
                      </button>
                    )}
                    <button className="btn btn-success mx-3" onClick={generateVariants}>
                      Save
                    </button>
                  </div>
                )}
                {isTracking && variants.length > 0 && (
                  <div className="table-responsive mt-3">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Variant Name</th>
                          <th>SKU (Auto-generated)</th>
                          <th>Barcode</th>
                          <th>Retail Price</th>
                          <th>Tax</th>
                          <th>Total Price</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {variants.map((variant, index) => (
                          <tr key={index}>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                value={variant.name}
                                onChange={(e) => handleChange(index, 'name', e.target.value)}
                                placeholder="Variant name"
                              />
                            </td>

                            <td>
                              <input
                                type="text"
                                className="form-control"
                                value={variant.sku}
                                onChange={(e) => handleChange(index, 'sku', e.target.value)}
                                placeholder="Auto-generated SKU"
                                style={{ backgroundColor: '#f8f9fa' }}
                              />
                            </td>

                            <td>
                              <input
                                type="text"
                                className="form-control"
                                value={variant.barcode || ''}
                                onChange={(e) => handleChange(index, 'barcode', e.target.value)}
                                placeholder="Variant barcode"
                              />
                            </td>

                            <td>
                              <input
                                type="number"
                                className="form-control"
                                value={variant.retailPrice}
                                onChange={(e) => handleChange(index, 'retailPrice', e.target.value)}
                                onKeyDown={preventNegativeSign}
                              />
                            </td>

                            <td>
                              <input type="text" className="form-control" value={variant.tax} disabled style={{ backgroundColor: '#f8f9fa' }} />
                            </td>

                            <td>
                              <input type="text" className="form-control" value={variant.totalRetailPrice} disabled style={{ backgroundColor: '#f8f9fa' }} />
                            </td>

                            <td>
                              <button className="btn btn-danger" onClick={() => removeVariant(index)} title="Remove this variant">
                                <FaTrash />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </>
            ) : (
              ''
            )}
            {selectedType === 'Composite' ? (
              <div className="col-8 mt-3">
                <h5>Included Products</h5>
                <p>Composite products contain specified quantities of one or more standard products.</p>

                <div className="d-flex align-items-center gap-3 mb-3">
                  <Select
                    options={[]}
                    value={selectedProduct}
                    onChange={setSelectedProduct}
                    menuPortalTarget={document.body}
                    placeholder="Search Products"
                    className="flex-grow-1"
                  />
                  <input
                    type="number"
                    min="0.1"
                    step="0.1"
                    className="form-control"
                    value={quantity}
                    onChange={(e) => setQuantity(parseFloat(e.target.value))}
                    style={{ width: '80px' }}
                  />
                  <button className="btn btn-primary" onClick={handleAddProduct}>
                    Add
                  </button>
                  <p className="center">Tip: Product Quantities can be less then 1</p>
                </div>

                {productsList.length > 0 && (
                  <div className="">
                    {productsList.map((item, index) => (
                      <div key={index} className="row mt-2">
                        <div className="col-3 start">{item.label}</div>
                        <div className="col-2">
                          <input
                            type="number"
                            value={item.quantity}
                            min="0.1"
                            step="0.1"
                            onChange={(e) => {
                              const newList = [...productsList];
                              newList[index].quantity = parseFloat(e.target.value);
                              setProductsList(newList);
                            }}
                            style={{ width: '80px' }}
                          />
                        </div>
                        <div className="col-4">
                          <button className="btn btn-danger" onClick={() => handleRemoveProduct(index)}>
                            X
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddItemsMaster;
